import { combineReducers } from "redux";
import category from "../features/admin/productmanagement/category/Slice";
import subcategory from "../features/admin/productmanagement/subcategory/Slice";
import childcategory from "../features/admin/productmanagement/childcategory/Slice";
import needsSlice from "../features/admin/productmanagement/needs/needsSlice";
import product from "../features/admin/productmanagement/product/Slice";
import offerProduct from "../features/admin/productmanagement/offerproduct/Slice";

const products = combineReducers({
  category: category,
  subcategory: subcategory,
  childcategory: childcategory,
  needs: needsSlice,
  product: product,
  offerProduct: offerProduct,
});

export default products;
